import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "overlay"]

  connect() {
    this.isOpen = false
  }

  open(event) {
    event.preventDefault()
    const contentHtml = event.currentTarget.dataset.modalContent
    const name = event.currentTarget.dataset.modalName
    const title = event.currentTarget.dataset.modalTitle
    const image = event.currentTarget.dataset.modalImage

    this.contentTarget.innerHTML = `
      <div class="flex flex-col md:flex-row gap-8">
        <div class="w-full md:w-1/3">
          <img src="${image}" alt="${name}" class="w-full h-auto rounded-xl shadow-lg object-cover aspect-[3/4]">
        </div>
        <div class="w-full md:w-2/3">
          <h2 class="text-3xl font-bold text-midnight-900 mb-2">${name}</h2>
          <p class="text-xl text-coolgray-600 mb-6 font-medium">${title}</p>
          <div class="prose prose-slate max-w-none text-coolgray-700 leading-relaxed overflow-y-auto max-h-[60vh] pr-4 custom-scrollbar text-justify">
            ${contentHtml.replace(/\n\n/g, '</p><p class="mb-4">').replace(/\n/g, '<br>')}
          </div>
        </div>
      </div>
    `

    this.modalTarget.classList.remove("hidden")
    // Use a small timeout to trigger the transition
    setTimeout(() => {
      this.overlayTarget.classList.remove("opacity-0")
      this.modalTarget.querySelector(".modal-panel").classList.remove("opacity-0", "translate-y-4", "sm:scale-95")
      this.modalTarget.querySelector(".modal-panel").classList.add("opacity-100", "translate-y-0", "sm:scale-100")
    }, 10)

    document.body.classList.add("overflow-hidden")
    this.isOpen = true
  }

  close() {
    this.overlayTarget.classList.add("opacity-0")
    this.modalTarget.querySelector(".modal-panel").classList.remove("opacity-100", "translate-y-0", "sm:scale-100")
    this.modalTarget.querySelector(".modal-panel").classList.add("opacity-0", "translate-y-4", "sm:scale-95")

    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 300)

    this.isOpen = false
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
